import React, { useEffect, useRef } from 'react';
import { CloseIcon } from './Icons';

export const Modal = ({
  isOpen,
  onClose,
  title,
  subtitle,
  children,
  footer,
  size = 'default',
  bodyClassName = '',
  footerClassName = '',
  headerClassName = '',
}) => {
  const modalRef = useRef(null);

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) onClose();
  };

  useEffect(() => {
    if (isOpen && modalRef.current) modalRef.current.focus();
  }, [isOpen]);

  if (!isOpen) return null;

  const sizeClasses = size === 'small' ? 'max-w-md' : size === 'large' ? 'max-w-3xl' : 'max-w-xl';

  return (
    <div
      className="fixed inset-0 bg-black/50 flex items-center justify-center p-5 z-50 animate-fadeIn"
      onMouseDown={handleBackdropClick}
      role="dialog"
      aria-modal="true"
    >
      <div
        ref={modalRef}
        className={`bg-white rounded-2xl w-full ${sizeClasses} max-h-[90vh] overflow-hidden shadow-2xl animate-modalIn outline-none`}
        tabIndex={-1}
      >
        <div className={`flex justify-between items-center px-6 py-5 border-b border-slate-200/50 ${headerClassName}`}>
          <div>
            <h2 className="text-lg font-semibold text-slate-800">{title}</h2>
            {subtitle && <p className="text-sm text-slate-500 mt-1">{subtitle}</p>}
          </div>
          <button
            className="w-8 h-8 flex items-center justify-center bg-slate-100 rounded-lg text-slate-500 
              hover:bg-slate-200 hover:text-slate-700 transition-all"
            onClick={onClose}
            aria-label="Close"
          >
            <CloseIcon />
          </button>
        </div>
        <div className={`p-6 overflow-y-auto max-h-[calc(90vh-140px)] ${bodyClassName}`}>
          {children}
        </div>
        {footer && (
          <div className={`flex gap-3 px-6 py-5 ${footerClassName || 'border-t border-slate-200/50 bg-slate-50'}`}>{footer}</div>
        )}
      </div>
    </div>
  );
};
